import getPortalLocData from '../config/loc';


let data = {
  fuelSavings: {
    newMpg: '',
    tradeMpg: '',
    newPpg: '',
    tradePpg: '',
    milesDriven: '',
    milesDrivenTimeframe: 'week',
    displayResults: false,
    dateModified: null,
    necessaryDataIsProvidedToCalculateSavings: false,
    savings: {
      monthly: 0,
      annual: 0,
      threeYear: 0
    }
  },
  locationDetail: {
    isFetching: false,
    selectedLocationId:'',
    // selectedLocationId:'4804847b-78b9-49bb-aebb-551efd8e4fab',
    // selectedLocationId:'22640B26-9777-46F7-8F5F-E57F369B1C56',

    startDate:new Date().toISOString(),
    untilDate:'',
    
    untilDateChanged:false,
    spaceAvailable:true,
    selectedLocation:{},
    selectedOffering:{},
    selectedOptionalServices:[],
    bookingDetail:{},
  },
  pricing:{
    isLoading: false,
    pricingModel:{},
    dealPricingModel:{},
    defaultPricingModel:{}
  },
  paymentDetail:{
    cardNumber:'',
    expiryDate:'',
    cvc:'',
    isFetching:false,
    validated:false,
    data:{}
  },
  accountDetails:{
    isFetching:false,
    firstName:"",
    lastName:"",
    email:"",
    phone:"",
    vehiclePlate:"",
    password:"",
    tcAccepted:false,
    data:{},
    vehicleData:null,
    addVehicleModal: {
      isFindingVehicle: false,

      // TODO 
      // probably don't want to commit this 
      attemptedFind: false,
      vehicleReg: "",
      make: "",
      model: "",
      licensePlate: "",
      color:""
    },
  },

  vehicles: {
    isFetching: false,
    list: [],
    error: null
  },
  
  authentication: {
    error: "",
    loggedIn: false,
    loggingIn: false,
    logInMultiAccount:false,
    data:{}
  }

};
data.locationDetail.selectedLocationId = getPortalLocData().locationID;


export default data;





// WEBPACK FOOTER //
// ./src/reducers/initialState.js